import { MonthlyExpenseGroup } from "../../types/monthly-expense.type";
import { AmountView } from "./monthlyExpenseMath";

export const COLUMN_GROUP_KEYS = ["DAILY", "SALES", "SALARY", "ADMIN"] as const;
export type ColumnGroupKey = (typeof COLUMN_GROUP_KEYS)[number];

export const COLUMN_GROUP_TITLE: Record<ColumnGroupKey, string> = {
  DAILY: "จากรายวัน (อนุมัติแล้ว)",
  SALES: "ฝ่ายขาย",
  SALARY: "เงินเดือน – จ่ายจาก HO",
  ADMIN: "ฝ่ายบริหาร",
};

/** The design opens ฝ่ายขาย and เงินเดือน, and folds the two widest groups. */
export const DEFAULT_EXPANDED: Record<ColumnGroupKey, boolean> = {
  DAILY: false,
  SALES: true,
  SALARY: true,
  ADMIN: false,
};

export const EXTRA_GROUP_OPTIONS: { value: MonthlyExpenseGroup; label: string }[] = [
  { value: "SALES", label: "ฝ่ายขาย (→ Sales)" },
  { value: "SALARY", label: "เงินเดือน – จ่ายจาก HO (→ Manager)" },
  { value: "ADMIN", label: "ฝ่ายบริหาร (→ Manager)" },
];

export const VIEW_OPTIONS: { value: AmountView; label: string; hint: string }[] = [
  { value: "MONTH", label: "ยอดเดือน", hint: "" },
  { value: "DAY", label: "รายวัน", hint: "÷ วันขายจริง" },
  { value: "ROUTE", label: "รายสาย", hint: "÷ วันขายจริง ÷ จำนวนสายจริง" },
];

export const EXTRA_COLUMN_TITLE = "เพิ่มเติม";
export const GROUP_TOTAL_TITLE = "รวม";
export const EXTRA_DESCRIPTION_MAX_LENGTH = 255;
export const EMPTY_TEXT = "–";
export const MINUS_SIGN = "−";
